export default __webpack_public_path__ + "static/media/startApp.9d3a9d76.png";